import { Rule } from "@shared/types";

export const SECURE_DEFAULT_SUBCATEGORY = "secure default";

export function isSecureDefault(rule?: Rule): boolean {
  return (
    rule?.definition.rules?.[0]?.metadata?.subcategory?.includes(
      SECURE_DEFAULT_SUBCATEGORY
    ) ?? false
  );
}
